import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "al-overlay",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "WootDash bloqueado"
}
const _hoisted_2 = { class: "al-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { appLocked, unlockApp } from '@/composables/useBiometricLogin'
import { performLogout } from '@/composables/useAutoLogout'
import { useLogo } from '@/composables/useLogo'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLockOverlay',
  setup(__props) {

const store = useStore()
const router = useRouter()
const { logoUrl } = useLogo()
const busy = ref(false)

async function unlock() {
  busy.value = true
  await unlockApp()
  busy.value = false
}

async function logout() {
  appLocked.value = false
  await performLogout(store, router)
}

return (_ctx: any,_cache: any) => {
  return (_unref(appLocked))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _unref(logoUrl),
            alt: "",
            class: "al-logo"
          }, null, 8, _hoisted_3),
          _cache[0] || (_cache[0] = _createElementVNode("h2", null, "WootDash bloqueado", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "Use a digital ou a senha do celular pra voltar às conversas.", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "al-btn",
            disabled: busy.value,
            onClick: unlock
          }, _toDisplayString(busy.value ? 'Aguardando…' : 'Desbloquear'), 9, _hoisted_4),
          _createElementVNode("button", {
            type: "button",
            class: "al-link",
            disabled: busy.value,
            onClick: logout
          }, "Sair e entrar com a senha", 8, _hoisted_5)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})